import { render, staticRenderFns } from "./TripCard.vue?vue&type=template&id=047636d4&scoped=true"
import script from "./TripCard.vue?vue&type=script&lang=js"
export * from "./TripCard.vue?vue&type=script&lang=js"
import style0 from "./TripCard.vue?vue&type=style&index=0&id=047636d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047636d4",
  null
  
)

export default component.exports